import { Dayjs } from "dayjs";
import { Content, ThinText } from "../../components/texts";
import { Service } from "../../interfaces/service";
import confirmLottie from "../../assets/lotties/confirm.json";
import Lottie from "lottie-react";

interface BookSuccessProps{
  selectedService: Service | undefined;
  selectedDate: Dayjs | null;
  selectedHour: string | null;
}

export default function BookSuccess({selectedDate, selectedHour, selectedService}: BookSuccessProps) {
  return (
    <div
      style={{
        textAlign: "center",
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <ThinText
        style={{
          fontSize: "2rem",
          marginBottom: "1rem",
        }}
      >
        Agendamento Confirmado!
      </ThinText>
      <Lottie
        animationData={confirmLottie}
        loop={false}
        style={{ width: "300px", height: "300px" }}
        initialSegment={[15, 100]}
      />
      <Content style={{ fontSize: "1.2rem", marginBottom: "0.5rem" }}>
        Seu horário para o serviço de <strong>{selectedService?.name}</strong>{" "}
        foi agendado com sucesso dia {selectedDate?.format("DD/MM/YYYY")} às{" "}
        {selectedHour}.
      </Content>
      <Content style={{ fontSize: "1.1rem" }}>
        Obrigado por agendar conosco!
      </Content>
    </div>
  );
}
